<template>
  <div>
    <header-component />
    <router-view></router-view>
    <footer-component />
  </div>
</template>

<script>
import headerComponent from "@/components/header.vue";
import footerComponent from "@/components/footer.vue";

export default {
  components: {
    headerComponent,
    footerComponent
  },
  beforeMount() {
    window.scrollTo(0, 0);
  }  
};
</script>